import { Component, Input, OnInit } from '@angular/core';
import { Jobs, StatusButtons } from "../../../../_shared/interfaces";
import { JobsStoreService } from "../../../../_shared/services";
import { RouterLink } from "@angular/router";
import { ClrDatagridModule, ClrDatagridSortOrder } from "@clr/angular";
import { CurrencyPipe, DatePipe, NgIf } from "@angular/common";

@Component({
  selector: 'app-project-details-jobs',
  standalone: true,
  imports: [
    ClrDatagridModule,
    RouterLink,
    DatePipe,
    NgIf,
    CurrencyPipe
  ],
  templateUrl: './project-details-jobs.component.html',
  styleUrl: './project-details-jobs.component.sass'
})
export class ProjectDetailsJobsComponent implements OnInit {
  jobs: Jobs[] = [];
  descSort = ClrDatagridSortOrder.DESC;
  loading: boolean = true;
  projectID: string = '';

  @Input() prid!: string;
  @Input() cid!: number;

  statusButtons: StatusButtons[] = [
    { state: '', display: '---', label: 'alert-danger', icon: 'info-circle'},
    { state: 'open', display: 'Entwurf', label: 'alert-info', icon: 'info-circle'},
    { state: 'confirmed', display: 'Auftrag bestätigt', label: 'alert-info', icon: 'info-circle'},
    { state: 'standard', display: 'Standard', label: 'alert-info', icon: 'info-circle'},
    { state: 'running', display: 'In Arbeit', label: 'alert-warning', icon: 'info-circle'},
    { state: 'invoiced', display: 'Berechnet', label: 'alert-danger', icon: 'check-circle'},
    { state: 'finished', display: 'Erledigt', label: 'alert-success', icon: 'info-circle'}
  ];

  constructor(
      private jobss: JobsStoreService
  ) { }

  ngOnInit(): void {
    this.loading = true;
    this.projectID = this.cid + '.' + this.prid;
    this.loadList(this.projectID);
  }

  // Anpassung Farbe und Text des Statusbuttons...
  findButtonStatus(projectstatus: string, buttons: StatusButtons[]) {
    return buttons.findIndex(el => el.state === projectstatus)
  };

  getCellStatus(projectstatus: string) {
    const statusline = this.findButtonStatus(projectstatus, this.statusButtons);
    return {
      'statusLabel' : this.statusButtons[statusline].label,
      'statusDisplay': this.statusButtons[statusline].display,
      'statusIcon': this.statusButtons[statusline].icon
    };
  }

  findButtonClass(invoicestatus: string) {
    return "alert " + this.getCellStatus(invoicestatus).statusLabel + " alert-sm";
  }

  loadList(projectID: string) {
    let status = 'all';
    this.jobss.getJobs(projectID, 0, status).subscribe(data => {
      if (!data) {
        return;
      }
      this.jobs = data.object;
      this.loading = false;
      this.descSort = ClrDatagridSortOrder.DESC;
    });
  }

}
